import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  fallback:false,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/pages/Home/index.vue')
    },
    {
      path: '/eguarantee',
      name: 'HelloWorld',
      component: () => import('@/views/pages/index.vue')
    },
    {
      path: '/details',
      name: 'details',
      component: () => import('@/views/pages/guarantee-detail/index.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js